import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import BgParallax from '../../components/bg-parallax'
import Partner from '../../components/partner'
import About from '../../components/about'
import TeamTwo from '../../components/team-two'
import BlogOne from '../../components/blog-one'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/cryptocurrency/bg01.jpg'
import aboutImg from '../../assets/images/cryptocurrency/crypto-cell.png'
import aboutImg2 from '../../assets/images/cryptocurrency/crypto.png'

import { aboutData, cryptoFeature, currencyData } from '../../data/crypto'
import {FiChevronRight} from '../../assets/icons/vander'

export default function IndexCryptocurrency() {
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="bg-half-260 d-table w-100">
      <BgParallax bg={bg1}/>
      <div className="bg-overlay" style={{opacity: '0.6'}}></div>
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-7">
                  <div className="title-heading position-relative mt-4" style={{zIndex: '1'}}>
                      <h5 className="text-white title-dark">0% trading commission</h5>
                      <h1 className="heading text-white title-dark fw-bold mb-3">Start the best <span className="text-primary fw-bold">Cryptocurrency</span> exchange</h1>
                      <p className="para-desc mx-auto title-dark text-light">Start work with Leaping. Build responsive, mobile-first projectsthe web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mb-2 me-2">Start Trading</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne textLight={true}/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row justify-content-center align-items-center">
              <div className="col-md-5 order-1 order-md-1 mt-4 pt-2">
                  <img src={aboutImg} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 order-2 order-md-2 ps-lg-5 mt-4 pt-2">
                  <div className="section-title">
                      <h2 className="mb-4 title">Easy to track your <br/> earnings & more easy</h2>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space. These alternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or nonsensical stories.</p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary">Learn more</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100">
          <div className="row justify-content-center align-items-center">
              <div className="col-lg-7 col-md-7 col-12 mt-4 pt-2 order-lg-2 odrer-md-2 odrer-sm-1">
                  <img src={aboutImg2} className="img-fluid" alt=""/>
              </div>
  
              <div className="col-lg-5 col-md-5 col-12 mt-4 pt-2 odrer-lg-1 order-md-1 order-sm-2">
                  <div className="section-title">
                      <h2 className="mb-4 title">Get more getailded insights more easyily & more fast</h2>
                      <div className="row g-4">
                        {aboutData.map((item,index)=>{
                          let Icon = item.icon
                          return(
                              <div className="col-lg-6 col-md-12" key={index}>
                                  <div className="btn-outline-primary py-2 px-3 d-flex align-items-center shadow rounded bg-light">
                                      <div>
                                          <Icon className="h2"/>
                                      </div>
                                      <div className="ms-3">
                                          <h5 className="m-0">{item.name}</h5>
                                          <span className="text-muted">{item.title}</span>
                                      </div>
                                  </div>
                              </div>
                          )
                        })}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section pb-3">   
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="title mb-4">Latest Cryptocurrency Table</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Start work with <span className="text-primary fw-bold">Leaping</span>. Build responsive, mobile-first projectsthe web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-12 mt-4 pt-2">
                  <div className="table-responsive shadow rounded-md">
                      <table className="border-secondary-subtle mb-0 table-center w-100">
                          <thead>
                              <tr>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3" style={{minWidth: '250px'}}>Name</th>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3" style={{width: '150px'}}>Price</th>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3" style={{width: '150px'}}>Change(%)</th>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3" style={{width: '150px'}}>Change($)</th>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3" style={{width: '150px'}}>Marketcap</th>
                                  <th scope="col" className="fw-semibold border-bottom text-dark py-4 px-3 text-end" style={{width: '100px'}}>Trade</th>
                              </tr>
                          </thead>

                          <tbody>
                            {currencyData.map((item,index)=>{
                              return(
                                  <tr key={index}>
                                      <th className="p-3 border-bottom">
                                          <div className="align-items-center">
                                              <p className="mb-0 d-inline fw-normal h6 text-dark">{item.name} <span className="text-muted">{item.title}</span> </p>
                                          </div>
                                      </th>
                                      <td className="border-bottom p-3 text-dark">{item.price}</td>
                                      <td className={`border-bottom p-3 ${item.status === 'loss' ? 'text-danger' : 'text-success'}`}>{item.perChange}</td>
                                      <td className={`border-bottom p-3 ${item.status === 'loss' ? 'text-danger' : 'text-success'}`}>{item.change}</td>
                                      <td className="border-bottom text-muted p-3">{item.marketCap}</td>
                                      <td className="border-bottom p-3 text-end"><Link to="#" className="btn btn-sm btn-primary">Trade</Link></td>
                                  </tr>
                              )
                            })}
                          </tbody>
                      </table>
                  </div>

                  <div className="mt-4 pt-2 text-center">
                      <Link to="#" className="text-primary h6">See More <FiChevronRight className="align-middle"/></Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="py-5">
        <div className="container">
            <Partner/>
        </div>
    </section>

    <section className="section bg-light" id="services">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Powerfull Features</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {cryptoFeature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-4 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <Icon className="h1 text-primary"></Icon>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.desc}</p>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <About/>
      </div>
    </section>

    <section className="section pt-0">
      <div className="container">
          <div className="row mb-4 pb-2 pt-4">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Our Dream Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamTwo/>
      </div>
    </section>

    <section className="section pt-0">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>
    <Footer/>
    </>
  )
}
